/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://jr7ehogqh5.execute-api.us-east-1.amazonaws.com/tmobiledev",
            "region": "us-east-1"
        },
        {
            "name": "TMOAmplifyApi",
            "endpoint": "https://mvbfp7s67f.execute-api.us-east-1.amazonaws.com/tmobiledev",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:323c27c8-d179-492b-b5e2-869e22062115",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_SCAIpnDgW",
    "aws_user_pools_web_client_id": "2dgp1j9d41stqeav2rtjcu70vf",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "FAMILY_NAME",
        "GIVEN_NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "tmo-content101243-tmobiledev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
